import { api } from '@/api';
import { ENTITY_STATUS, sortByStatus, withStatus } from '@/helpers/entityStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    tags: [],
    isLoading: false,

    current: {
      isLoading: false,
    },
    currentTopViewUrl: null,
    designFiles: [],
    deprecatedItems: [],
    objects: [],
    deletedItems: [],
  },
  mutations: {
    setMaterials(state, items) {
      state.items = items;
    },
    setMaterialsTags(state, tags) {
      state.tags = tags;
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    setCurrentMaterial(state, data) {
      state.current = {
        ...state.current,
        ...data,
      };
    },
    setCurrentLoading(state, loading) {
      state.current.isLoading = loading;
    },
    setDeprecatedMaterial(state, items) {
      state.deprecatedItems = items;
    },
    setDeletedMaterial(state, deletedItems) {
      state.deletedItems = deletedItems;
    },
    setMaterialObjects(state, objects) {
      state.objects = objects;
    },
  },
  actions: {
    // Один список на все состояния: is_archived=true отдаёт только корзину,
    // поэтому три запроса не пересекаются.
    async getMaterialObjects({ commit }) {
      commit('setLoading', true);

      try {
        const [actual, deprecated, archived] = await Promise.all([
          api.getMaterialsList({ is_deprecated: false }),
          api.getMaterialsList({ is_deprecated: true }),
          api.getMaterialsList({ is_archived: true }),
        ]);

        commit('setMaterialObjects', sortByStatus([
          ...withStatus(actual.data, ENTITY_STATUS.ACTUAL),
          ...withStatus(deprecated.data, ENTITY_STATUS.DEPRECATED),
          ...withStatus(archived.data, ENTITY_STATUS.ARCHIVED),
        ]));
      } finally {
        commit('setLoading', false);
      }
    },

    getList(store) {
      store.commit('setLoading', true);

      const params = { page: store.state.page, is_deprecated: false };

      return api.getMaterialsList(params).then(({ data }) => {
        store.commit('setMaterials', data);
        store.commit('setLoading', false);
      });
    },

    getDeprecatedMaterialsList({ commit, state }) {
      commit('setLoading', true);
      const params = {
        page: state.page,
        is_deprecated: true,
      };
      return api.getMaterialsList(params)
        .then(({ data }) => {
          commit('setDeprecatedMaterial', data);
        })
        .finally(() => commit('setLoading', false));
    },

    getDeletedMaterialsList(store) {
      store.commit('setLoading', true);

      const params = { page: store.state.page, is_archived: true };

      return api.getMaterialsList(params).then(({ data }) => {
        store.commit('setDeletedMaterial', data);
        store.commit('setLoading', false);
      });
    },

    getMaterialsTags(store) {
      store.commit('setLoading', true);

      const params = { page: store.state.page };

      return api.getMaterialsTags(params).then(({ data }) => {
        store.commit('setMaterialsTags', data);
        store.commit('setLoading', false);
      });
    },

    async getMaterial({ commit }, id) {
      const response = await api.getMaterialById(id);
      commit('setCurrentMaterial', response.data);
      return response.data;
    },

    async invalidateUnrealMaterials() {
      return api.invalidateMaterials().then((resp) => resp);
    },

    async updateMaterialPlanStyles({ commit, dispatch }, { id, planStyles }) {
      await api.updateMaterialPlanStyles(id, planStyles);
      const updatedMaterial = await dispatch('getMaterial', id);

      commit('setCurrentMaterial', updatedMaterial);
      return updatedMaterial;
    },

    async updateMaterialRoomTypes({ commit, dispatch }, { id, roomTypes }) {
      await api.updateMaterialRoomTypes(id, roomTypes);
      const updatedMaterial = await dispatch('getMaterial', id);

      commit('setCurrentMaterial', updatedMaterial);
      return updatedMaterial;
    },

    async updateMaterialTags({ commit, dispatch }, { id, tags }) {
      await api.updateMaterialTags(id, tags);
      const updatedMaterial = await dispatch('getMaterial', id);

      commit('setCurrentMaterial', updatedMaterial);
      return updatedMaterial;
    },

    deleteMaterialById({ commit, state, dispatch }, id) {
      return api.deleteMaterial(id).then(() => {
        const updatedMaterials = state.items.filter((item) => item.id !== id);

        commit('setMaterials', updatedMaterials);

        return dispatch('getDeletedMaterialsList');
      }).catch((error) => {
        console.error('Ошибка при удалении материала:', error);
        throw error;
      });
    },

    restoreMaterial({ commit, state, dispatch }, id) {
      return api.restoreMaterial(id, { is_archived: false }).then(() => {
        const updatedDeletedItems = state.deletedItems.filter((item) => item.id !== id);

        commit('setDeletedMaterial', updatedDeletedItems);

        return dispatch('getList');
      }).catch((error) => {
        console.error('Ошибка при восстановлении материала:', error);
        throw error;
      });
    },

    createMaterialTag(store, request) {
      return api.createMaterialTag(request).catch((error) => {
        console.error('Ошибка при создании тега:', error);
        throw error;
      });
    },

  },
};
